import { IOffersStatsItem, OffersStatsItem, OffersStatsItemMobile } from '../../components/OffersStats';
import { Responsive } from '@cian/ui-kit';

export const OffersStatsItemContainer = (props: IOffersStatsItem) => {
  return (
    <>
      <Responsive phone tablet>
        <OffersStatsItemMobile {...props} />
      </Responsive>
      <Responsive desktop>
        <OffersStatsItem {...props} />
      </Responsive>
    </>
  );
};
